import React from "react";
import { useController } from "react-hook-form";
import AsyncSelect from "../../containers/logistic/shipmentNotifications/components/AsyncSelect";
import { FormControl, FormItem, FormLabel, FormMessage } from "../ui/form";

interface SelectFormAsyncProps {
  name: string;
  label: string;
  placeholder: string;
  onSearch: (query: string) => Promise<Array<{ id: number; name: string }>>;
  className?: string;
  disabled?: boolean;
}

export const SelectFormAsync: React.FC<SelectFormAsyncProps> = ({
  name,
  label,
  placeholder,
  onSearch,
  className,
  disabled = false,
}) => {
  const {
    field,
    fieldState: { error },
  } = useController({
    name,
  });

  return (
    <FormItem className={className}>
      <FormLabel className={error ? "text-destructive" : ""}>
        {label} <span className={error ? "text-destructive" : undefined}>(*)</span>
      </FormLabel>
      <FormControl>
        <AsyncSelect
          value={field.value}
          onChange={field.onChange}
          onSearch={onSearch}
          placeholder={placeholder}
          label=""
          disabled={disabled}
        />
      </FormControl>
      <FormMessage />
    </FormItem>
  );
}; 